import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// import ReactGA from 'react-ga';

import { RootState } from 'app/redux/store';

import { SchoolAutoDiscoverState, SchoolAutoDiscoverApiResponse, SchoolUiSettings } from '../types';

const initialState: SchoolAutoDiscoverState = {
  schoolTimezone: '',
  schoolIsPublic: false,
  schoolUuid: '',
  schoolName: '',
  schoolAlias: '',
  tenantUuid: '',
  apiGatewayUrl: '',
  fileGatewayUrl: '',
  defaultAppUrl: '',
  defaultAdmUrl: '',
  uiSettings: {
    favIconUrl: '',
    logoUrl: '',
    logoDarkUrl: '',
    primaryColor: '',
    secondaryColor: '',
  },
  features: {
    hasEducationalInstitution: false,
    hasActivationCodeBatch: false,
  },
  schoolMelver: false,
};

const schoolSlice = createSlice({
  name: 'school',
  initialState,
  reducers: {
    setSchoolProcess(state, action: PayloadAction<SchoolAutoDiscoverApiResponse>) {
      const {
        tenantUuid,
        schoolUuid,
        schoolName,
        schoolAlias,
        schoolTimezone,
        schoolIsPublic,
        apiGatewayUrl,
        fileGatewayUrl,
        defaultAppUrl,
        defaultAdmUrl,
        uiSettings,
        features,
      } = action.payload;

      state.tenantUuid = tenantUuid;
      state.schoolUuid = schoolUuid;
      state.schoolName = schoolName;
      state.schoolAlias = schoolAlias;
      state.schoolTimezone = schoolTimezone;
      state.schoolIsPublic = schoolIsPublic;
      state.apiGatewayUrl = apiGatewayUrl;
      state.fileGatewayUrl = fileGatewayUrl;
      state.defaultAppUrl = defaultAppUrl;
      state.defaultAdmUrl = defaultAdmUrl;
      state.uiSettings = { ...uiSettings };
      state.features = { ...features };

      const isMelverSchool = schoolUuid === '00782645-8e0a-ec11-9de3-42010ab60002' || schoolUuid === 'e16f261c-eea5-4757-b333-c6e8fdcbf57d';
      state.schoolMelver = isMelverSchool;

      if (process.env.NODE_ENV === 'production') {
        state.apiGatewayUrl = window.location.origin;
      }

      // state.apiGatewayUrl = 'http://ipv4.fornazinconsultoria.com.br:54321';
      // state.apiGatewayUrl = 'http://localhost:54321';
      // state.directApiGatewayUrl = state.apiGatewayUrl
    },

    setSchoolUiSettingsProcess(state, action: PayloadAction<Partial<SchoolUiSettings>>) {
      state.uiSettings = {
        ...state.uiSettings,
        ...Object.keys(action.payload)
          .filter((key) => {
            return !!action.payload[key as keyof SchoolUiSettings];
          })
          .reduce((prev, item) => {
            return { ...prev, [item]: action.payload[item as keyof SchoolUiSettings] };
          }, {} as Partial<SchoolUiSettings>),
      };
    },
  },
});

export const { setSchoolProcess, setSchoolUiSettingsProcess } = schoolSlice.actions;

export const getSchool = (state: RootState): SchoolAutoDiscoverState => state.school;

export default schoolSlice.reducer;
